import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, message } from 'antd';
import { getSetupCost, updateBusiness } from '../../api/payment';
import { check } from '../../store/slices/checkSlice';
import Button from '../common/button';
import { colors } from '../../share/constants/enums';
import { Link } from 'react-router-dom';

const Summary = ({ business }) => {
  const dispatch = useDispatch();
  const [cost, setCost] = useState();
  const [couponApplied, setCouponApplied] = useState(false);
  const discount = useSelector((state) => {
    return state.discount;
  });

  const setupCost = async (payload) => {
    try {
      const res = await getSetupCost(payload);
      if (res) {
        setCost(res);
        if (res.discountTotalAmount) {
          setCouponApplied(true);
          dispatch(check('correct'));
          message.success('Coupon code applied successfully');
        } else {
          dispatch(check('not-correct'));
        }
      }
    } catch (error) {
      console.error('Error applying coupon:', error);
      message.error('Error applying coupon');
    }
  };

  useEffect(() => {
    setupCost(discount);
  }, [discount]);
  return (
    <>
      <div className="flex flex-col w-full items-start">
        <div className="w-full">
          <div className="w-full">
            <div className="flex flex-col justify-center items-start  mt-5  border-boxGrey border-solid rounded-sm shadow-md ">
              <div className="p-2 w-90% md:grid md:grid-cols-3">
                <div className="md:col-span-2">
                  <p className="text-primaryPurple">Summary</p>
                  <p>Ongoing Monthly Check Out</p>
                </div>

                <div className="w-full md:col-span-1 md:grid md:grid-cols-4">
                  <div>
                    <Divider type="vertical" className="md:h-full" />
                  </div>
                  <div className="md:col-span-3">
                    <p className="text-primaryPurple md:flex md:justify-end">
                      Total Price
                    </p>
                    <p>
                      Setup Cost
                      <span className="text-primaryOrange float-right">
                        ${cost?.setupCost}
                      </span>
                    </p>
                    <p>
                      Ongoing Monthly
                      <span className="text-primaryOrange float-right">
                        ${cost?.monthlyCost}
                      </span>
                    </p>
                    {business.isChequePayment ? (
                      <p className="text-sm text-primaryPurple">
                        * Monthly subscription fee will be charged from next
                        month
                      </p>
                    ) : (
                      ''
                    )}
                    <p className="text-primaryPurple lg:flex lg:justify-end">
                      Total Price To Be Paid
                    </p>
                    <span className="text-primaryOrange float-right">
                      $
                      {cost?.discountTotalAmount ? (
                        <>
                          <s>{cost?.total}</s> <br />$
                          {cost?.discountTotalAmount}
                        </>
                      ) : (
                        cost?.total
                      )}
                    </span>
                    {couponApplied && ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            cost?.monthlyCost ? <p className="text-sm text-primaryPurple">
            *After This Initial Payment, You'll Pay ${cost?.monthlyCost} Per Month As Your YupUp
            Vendor Fee
          </p> : ""}
          
        </div>
      </div>
    </>
  );
};

export default Summary;
